import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { Wrapper } from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";
import { MaintenanceRequestForm } from "./From/Form";

export const MaintainanceRequestCreateScreenContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const { isFromHome } = location.state
    ? (location.state as { isFromHome: boolean })
    : { isFromHome: false };

  return (
    <Wrapper isAuthorizedWrapper idSelector={"wrapperContainer"}>
      <ContentContainer size="narrow">
        <PageHeader
          title={t("requests.addOrUpdateRequest.newRequestTitle")}
          onBack={() => navigate(isFromHome ? "/home" : "/requests")}
        />
        <MaintenanceRequestForm t={t} navigate={navigate} />
      </ContentContainer>
    </Wrapper>
  );
};
